import styled from '@emotion/styled';
import { colors, spacing, typography } from '#themes/stena-recycling';

export const ItemRowStyled = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  background: ${({ selected }) => (selected ? colors.background.grey : 'transparent')};

  &:hover {
    background: ${colors.background.grey};
  }
`;

export const ItemButtonStyled = styled.button<{ selected?: boolean }>`
  ${typography.body.large};
  color: ${colors.base.black};
  flex: 1;
  min-width: 0;
  padding: ${spacing.xsmall} ${spacing.xmsmall};
  cursor: pointer;
  background: transparent;
  border: 0;
  text-align: left;
  outline: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:focus-visible {
    outline: 0;
  }
`;

export const ItemDeleteButtonWrapper = styled.div`
  flex-shrink: 0;
  padding-right: ${spacing.xxsmall};
`;
